export const tenantEvChargersModuleAccessKeys = {
  all: ["tenant", "ev-chargers-module-access"] as const,
};
